export default {
    validate(root, freights, forwardType, stock, fromStock, toStock, date) {

        if (!root || !freights || !forwardType || !date) return {
            'canSave':           false,
            'hasFreightsErrors': false,
            'freightsErrors':    false,
            'freightsWarnings':  false,
            'error': 'Не указанны обязательные параметры маршрутного листа'
        };

        this.forwardType = (forwardType) ? parseInt(forwardType) : null; //1 - Экспедирование, 2 - Перевозка
        this.stock       = (stock)       ? stock        : null;
        this.fromStock   = (fromStock)   ? fromStock    : null;
        this.toStock     = (toStock)     ? toStock      : null;

        this.stockId     = (stock)       ? stock.id     : null;
        this.fromStockId = (fromStock)   ? fromStock.id : null;
        this.toStockId   = (toStock)     ? toStock.id   : null;
        
        this.date = date;
        this.root = root;

        this.hasFreightsErrors = false;
        this.canSave = true;
        this.freightsErrors = [];
        this.freightsWarnings = [];

        freights.forEach(freight => {

            if (!this.freightsErrors[freight.id]) this.freightsErrors[freight.id] = [];
            this.freightsErrors[freight.id] = [];

            if (!this.freightsWarnings[freight.id]) this.freightsWarnings[freight.id] = [];
            this.freightsWarnings[freight.id] = [];

            //По умлочанию включаем только следующие валидаторы
            let validator = [
                this.checkFreightData(freight),
                this.checkDealStatus(freight.deal),
                this.checkFreightCompleted(freight),
                this.checkFreightLocation(freight, stock),
                this.checkFreightTracking(freight),
                this.checkFreightStatus(freight),
            ];
            //Если тип перевозки "Экспедирование", то включаем остальные валидаторы
            if (this.forwardType == 1) validator = validator.concat([
                this.checkDealIssueStatus(freight.deal, freight),
                this.checkFreightDate(freight.deal),
                this.checkDealCustomers(freight.deal, freight.id),
                this.checkDealCustomerDebt(freight.deal, freight.id)
            ]);
        

            validator.map(item => {
                if (item.e)  this.freightsErrors[freight.id].push(item.e);
                if (item.w)  this.freightsWarnings[freight.id].push(item.w);
                if (!item.c) this.canSave = false;
            });

            this.freightsErrors[freight.id]   = this.array_unique(this.freightsErrors[freight.id]);
            this.freightsWarnings[freight.id] = this.array_unique(this.freightsWarnings[freight.id]);

            if (this.freightsErrors[freight.id] && this.freightsErrors[freight.id].length) this.hasFreightsErrors = true;
        });

        return {
            'canSave':           this.canSave,
            'hasFreightsErrors': this.hasFreightsErrors,
            'freightsErrors':    this.freightsErrors,
            'freightsWarnings':  this.freightsWarnings
        };
    },

    array_unique(array){
        return array.filter(function(el, index, arr) {
            return index == arr.indexOf(el);
        });
    },

    checkFreightStatus(freight) {
        if (!this.forwardType) return {e: null, w: null, c: true};
        if (freight.status && parseInt(freight.status.tracking_type) === 6) return {e: 'Груз уже выдан получателю.', w: null, c: false};
        return {e: null, w: null, c: true};
    },
    checkFreightTracking(freight) {
       if (!this.forwardType) return {e: null, w: null, c: true};
       //Если тип перевозки не "Экспедирование" и нет трекинга, то такой груз нельзя добавлять в МЛ
       if (parseInt(this.forwardType) != 1 && (!freight.currenttracking || !freight.currenttracking.id))
         return {e: 'У груза не установленно текущее местоположение. Перевозка невозможна.', w: null, c: false};

       return {e: null, w: null, c: true};
    },
    checkFreightLocation(freight, stock) {
       if (!this.forwardType) return {e: null, w: null, c: true};
       let message = {e: null, w: null, c: true};

        if (parseInt(this.forwardType) === 2) { //Если тип - Внутренняя перевозка
            if (!this.fromStockId || !this.fromStock) return {e: 'Не установлен склад отправления. Перевозка невозможна.', w: null, c: false};
            if (!this.toStockId   || !this.toStock)   return {e: 'Не установлен склад назначения. Перевозка невозможна.', w: null, c: false};
            if (!freight.currenttracking || !freight.currenttracking.id || !freight.currenttracking.stock_id) {
                return {e: 'У груза не установленно текущее местоположение. Перевозка невозможна.', w: null, c: false};
            } else {
                if (parseInt(freight.currenttracking.stock_id) != parseInt(this.fromStockId)) 
                    return {e: 'Текущее местоположение груза отличается от выбранного склада отправления. Перевозка невозможна.', w: null, c: false};
            }
        }

        if (parseInt(this.forwardType) === 1) { //Если тип - Экспедирование
            if (!stock) return {e: 'Не установлен склад экспедирования. Перевозка невозможна.', w: null, c: false};
            let ForwardType = ((freight.current_forward_method) ? parseInt(freight.current_forward_method) : this.getFreightForwardMethod(freight));
            if (!ForwardType || parseInt(ForwardType) === 0) { //Если вернулось 0, значит ошибка
                return {e: 'Экспедирование груза невозможно ни в одном из пунктов, проверьте данные груза. Перевозка невозможна.', w: null, c: false};
            } else if (parseInt(ForwardType) == 1) { //Проверяем пункт отправления
                if (freight.deal && freight.deal.from_address && freight.deal.from_address.city) {
                    if (parseInt(stock.city.zone_id) !== parseInt(freight.deal.from_address.city.zone_id))
                        return {e: null, w: 'Выбранный склад маршрутного листа не совпадает с населённым пунктом отправления груза. Экспедирование за пределами направления склада.', c: true};

                    if (parseInt(stock.city.id) !== parseInt(freight.deal.from_address.city.id)) 
                        return {e: null, w: 'Внимание! Забор груза будет осуществлен по направлению.', c: true};

                } else return {e: 'У груза некорректно установлен адрес отправления, проверьте данные груза. Перевозка невозможна.', w: null, c: false};
            } else if (parseInt(ForwardType) == 2) { //Проверяем пункт назначения
                if (!freight.currenttracking || !freight.currenttracking.id || !freight.currenttracking.stock_id) 
                    return {e: 'У груза не установленно текущее местоположение. Перевозка невозможна.', w: null, c: false};

                if (!freight.deal || !freight.deal.to_address || !freight.deal.to_address.city_id)
                    return {e: 'У груза некорректно установлен адрес назначения, проверьте данные груза. Перевозка невозможна.', w: null, c: false}; 

                if (parseInt(stock.id) !== parseInt(freight.currenttracking.stock_id))
                    return {e: 'Груз не находится на выбраном складе отправления. Перевозка невозможна.', w: null, c: false}; 
            }
        }

        return message;
    },
    checkFreightDate(deal) {
        if (!this.forwardType) return {e: null, w: null, c: true};
        let date    = (deal.forwarding_date_from) ? this.root.moment(deal.forwarding_date_from) : null;
        let current = this.root.moment(this.date);
        let message = {e: null, w: null, c: true};

        if (!date || !this.date || !deal.forwarding_date_from) return message;

        switch (parseInt(this.forwardType)) {
            case 1: //Экспедирование
                if (current.isAfter(date, 'day'))       message = {e: null, w: 'Выбранная дата позже даты экспедирования груза', c: true};
                else if (current.isBefore(date, 'day')) message = {e: null, w: 'Выбранная дата раньше даты экспедирования груза', c: true};
            break;
            case 2: //Перевозка
                if (current.isBefore(date, 'day')) message = {e: 'Выбранная дата перевозки не может быть раньше даты забора груза', w: null, c: true};
            break;
        }

        return message;
    },
    checkFreightCompleted(freight) {
        //Если нет МЛ, то груз ещё находится у клиента либо уже на складе и никуда не ездил, значит его можно добавлять в любой МЛ
        //Или если по предыдушему МЛ груз уже отработан
        if (!this.forwardType || !freight.current_routelist || !freight.current_routelist.id || freight.is_current_routelist_completed) return {e: null, w: null, c: true};
        //Иначе у груза есть текущий МЛ и он НЕ выполнен
        let errorMessage = (
            'Груз ещё не обработан по предыдущему маршрутному листу ' + '№' + freight.current_routelist.id + 
                (parseInt(freight.current_routelist.type) === 1 ? ' (Экспедирование)' : ' (Внутренняя перевозка)' ) + 
                '. Убедитесь в коррекности выбора грузов!'
            );
        //Если тип - "Внутренняя перевозка" и по предыдущему МЛ груз ещё не отработан
        if (parseInt(this.forwardType) === 2) return {e: errorMessage, w: false, c: false};
        

        //Если тип - "Экспедирование" и по предыдущему МЛ груз ещё не отработан
        if (parseInt(this.forwardType) === 1) {
            //1. Текущий МЛ груза - "Экспедирование"
            if (parseInt(freight.current_routelist.type) === 1) return {e: errorMessage, w: false, c: false};

            //2. Текущий МЛ груза - "Внутренняя перевозка", то такой МЛ можно создвавать в случае, если этот МЛ уже в работе (т.е. машина с грузами уже уехала)
            if (parseInt(freight.current_routelist.type) === 2 && parseInt(freight.current_routelist.status_id) !== 4) 
                return {e: ('Груз ещё не выдан на перемещение по маршрутному листу ' + '№' + freight.current_routelist.id), w: false, c: false};
        }

        return {e: null, w: null, c: true};
    },
    checkDealCustomers(deal, freightId) {
        if (!this.forwardType) return {e: null, w: null, c: true};
        let message = {e: null, w: null, c: true};
        if (!deal.sender_id || !deal.recipient_id || !deal.payer_id || !deal.applicant_id) {
            message = {e: 'У заявки не указаны контрагенты', w: null, c: false};

            let customers = [];
            if (!deal.sender_id)    customers.push('отправитель');
            if (!deal.recipient_id) customers.push('получатель');
            if (!deal.payer_id)     customers.push('плательщик');
            if (!deal.applicant_id) customers.push('заявитель');

            if (customers.length) message.e += ': ' + customers.join(', ') + '.';
        }
        return message;
    },
    checkDealCustomerDebt(deal, freightId) {
        if (!this.forwardType) return {e: null, w: null, c: true};
        let message = {e: null, w: null, c: true};
        if (parseInt(this.forwardType) != 1) return message;
        if (!deal || !deal.payer_id || !deal.payer)  return message;
        if (parseInt(deal.payer.can_issue_freight) == 0) message.w = 'Выдача груза запрещена' + ((deal.payer && deal.payer.name) ? (' для плательщика ' + deal.payer.name) : '');

        return message;
    },
    checkDealStatus(deal) {
        if (!deal || !deal.status) return {e: null, w: null, c: true};
        if (deal.status.type == 'canceled') return {e: 'Отменённую заявку невозможно добавить в маршрутный лист', w: null, c: false};
        if (deal.status.type == 'accepted') return {e: 'Для добавления в маршрутный лист заявка должна иметь статус "Подтвержена"', w: null, c: false};

        return {e: null, w: null, c: true};
    },
    checkDealIssueStatus(deal, freight) {
        if (
            !deal || !freight || // Если не переданы груз и заявка
            parseInt(deal.status_issue_id) === 1 || // если статус выдачи "Выдача разрешена"
            parseInt(freight.current_forward_method) !== 2 // Если текущий метод экспедирования НЕ "Выдача"
        ) return {e: null, w: null, c: true};

        // Если груз запретил выдавать администратор
        if (parseInt(deal.status_issue_id) === 2 && parseInt(deal.status_issue_type_id) === 3) return {e: 'Выдача груза запрещена администратором', w: null, c: false};
        // Если у груза включилась услуга "Сверхнормативное хранение"
        if (parseInt(deal.status_issue_id) === 2 && parseInt(deal.status_issue_type_id) === 2) return {e: 'Груз имеет сверхнормативное хранение, выдача невозможна', w: null, c: false};
        // Если у плательщиков по грузам есть задолженность
        if (parseInt(deal.status_issue_id) === 2 && parseInt(deal.status_issue_type_id) === 1) return {e: 'Плательщики по заявке имеют задолженность, выдача невозможна', w: null, c: false};
        // Если у плательщиков по грузам есть задолженность и разрешено только экспедирование, предупреждаем об этом
        if (parseInt(deal.status_issue_id) === 3 && parseInt(deal.status_issue_type_id) === 1) return {e: null, w: 'Плательщики по заявке имеют задолженность, разрешено только экспедирование', c: true};

        return {e: null, w: null, c: true};
    },
    checkFreightData(freight) {
        if (!freight.size || !freight.weight || !freight.seats_number) 
            return {e: 'У груза не установлен один из обязательных параметров (вес, объём, кол-во мест)', w: null, c: true};

        return {e: null, w: null, c: true};
    },
    /**
     * Проверяет надо выдать груз клиенту или забрать у клиента
     * Метод только для типа МЛ - "Экспедирование"
     */
    getFreightForwardMethod(freight) {
        // 1 - Терминал, 2 - Экспедирование

        //Если метод отправки со склада и метод доставки до склада, то этот груз нельзя экспедировать и надо вернуть fase (интикатор ошибки)
        if (parseInt(freight.deal.delivery_method_from) === 1 && parseInt(freight.deal.delivery_method_to) === 1) return 0;

        //Если у груза ещё нет трекинга, значит он сейчас находится у клиента и его ещё не забрали
        //Тут других вариантов быть не может, груз/заявка без трекинга создаётся только в одном случае - для экспедирования в пункте отправления
        if (!freight.currenttracking || !freight.currenttracking.id) {
            //Если метод отправки выбран "Экспедирование" значит метод экспедирования - Забор
            if (parseInt(freight.deal.delivery_method_from) === 2) return 1;
            else return 0; //Если метод отправки "Со склада", а трекинга нет, значит этот груз с ошибкой (такой ситуации быть не должно), следовательно груз нельзя экспедировать
        }
        //Если трекинг есть, значит его либо уже забрали у клиента, либо клиент сам его сдал на склад.
        //В обоих случаях экспедирование может быть только в пункте назначения
        else {
            //Если метод доставки выбран "Экспедирование" значит метод экспедирования - Выдача
            if (parseInt(freight.deal.delivery_method_to) === 2) return 2;
            else return 0; 
            //Если метод доставки "До склада", значит мы не можем экспедировать этот груз т.к. 
            //в пункте отправления он уже обработан, а в пункте назначения экспедирование не требуется
        }

        return 0;
    },
}


// WEBPACK FOOTER //
// ./src/helpers/RoutelistValidator/index.js